var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.8154 28.9336L24.2883 23.4062C25.507 21.9844 26.214 20.1445 26.214 18.125C26.214 13.6367 22.5763 10 18.0894 10C13.6026 10 10 13.6379 10 18.125C10 22.6121 13.6373 26.25 18.0894 26.25C20.1081 26.25 21.9506 25.5094 23.3704 24.291L28.8975 29.8184C29.0537 29.9375 29.2139 30 29.374 30C29.5342 30 29.6938 29.939 29.8158 29.8169C30.0615 29.5742 30.0615 29.1758 29.8154 28.9336ZM18.1246 25C14.3006 25 11.2499 21.9141 11.2499 18.125C11.2499 14.3359 14.3006 11.25 18.1246 11.25C21.9486 11.25 24.9992 14.3008 24.9992 18.125C24.9992 21.9492 21.9135 25 18.1246 25Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.1a59678d9ae3cae72526b9275d415501.svg";
export { ForwardRef as ReactComponent };